import moment from 'moment';
import React, { useState } from 'react'
import { connect } from 'react-redux';
import { getTintControlData, setCurrentWindowTintPage, setCurrentZoneStep, seTintControlData, setSelectedTintLevel, setSelectedWindows, updateSchedule } from '../../../../../action/roomControlAction';
import { closeOrderPopUp } from '../../../../action/hCommerce2';
import { setLoader } from '../../../../action/homeAction';
import view_logo from '../assets/view_sw_logo.png'

function convertToHHmmXMFormat(s) {
  var time = s.split("T")[1].split(":");
  var hour = time[0];
  var xM = "";
  if (hour > 12) {
    hour = hour - 12;
    xM = "PM";
  } else {
    xM = "AM";
  }
  var minute = time[1];
  return hour + ":" + minute + " " + xM;
}

function updateValuesFromTintResponse(response) {

  let utcOffsetMin = response.schedules.sunriseSunsetData.utcOffsetMinutes;
  //convert ISO to HH:mm A
  if(!response.schedules.sunriseSunsetData.sunrise || response.schedules.sunriseSunsetData.senset) return {"sunrise": "", "sunset": ""}
  let sunSetString = convertToHHmmXMFormat(
    response.schedules.sunriseSunsetData.sunrise
  );

  let sunRiseString = convertToHHmmXMFormat(
    response.schedules.sunriseSunsetData.sunset
  );

  let sunrise = moment(sunSetString, "h:mm A")
    .add(utcOffsetMin, "minutes")
    .format("h:mm A");

  let sunset = moment(sunRiseString, "h:mm A")
    .add(utcOffsetMin, "minutes")
    .format("h:mm A");

  return {sunrise, sunset};
}

function updateValuesFromTintResponseForSleepResponse(response){

  console.log(response)

  let utcOffsetMin = response.schedules.sunriseSunsetData.utcOffsetMinutes;

  if(response.schedules.sleepIn.length === 0){
    return{"bedTime": false , "wakeUP": false }
  }else{

    if(response.schedules.sleepIn[0].tintStartDate){

      let bedTimeString = convertToHHmmXMFormat(response.schedules.sleepIn[0].tintStartDate)
      let wakeUPString = convertToHHmmXMFormat(response.schedules.sleepIn[0].tintEndDate)

      let bedTime = moment(bedTimeString,"h:mm A").add(utcOffsetMin, "minutes").format("h:mm A");
      let wakeUP = moment(wakeUPString,"h:mm A").add(utcOffsetMin, "minutes").format("h:mm A"); 

      return { bedTime , wakeUP }
    }else{
      return{"bedTime": false , "wakeUP": false }
    }
  }
}

function getDoubleDigit(num){
  if(num <= 9){
      return `0${num}`
  }
  return num
}

function WindowSleepin(props) {
  const [selectedStartHour, setSelectedStartHour] = useState("08")
  const [selectedStartMinute, setSelectedStartMinute] = useState("00")
  const [selectedStartAMpm, setSelectedStartAMpm] = useState("PM")

  const [selectedEndHour, setSelectedEndHour] = useState("07")
  const [selectedEndMinute, setSelectedEndMinute] = useState("00")
  const [selectedEndAMpm, setSelectedEndAMpm] = useState("AM")

  let utcOffsetMin = props.tintControlData.schedules.sunriseSunsetData.utcOffsetMinutes;

  const deleteSchedule = () => {
    props.setLoader(true, "Deleting Sleep In Schedule...")
    props.updateSchedule(props.guestDetail, [], () => {

      let tintData = {...props.tintControlData}
      let tintSchedule = tintData.schedules

      props.closeOrderPopUp(true, "Canceled Sleep-In.", "", false)
      props.setLoader(false, "")
      props.setCurrentWindowTintPage("")
      props.setSelectedWindows([])
      props.setSelectedTintLevel(1)
      props.setCurrentZoneStep(1)

      tintSchedule['sleepIn'] = []
      tintData['schedules'] = tintSchedule

      console.log("tintData", tintData);
      
      props.seTintControlData(tintData)

      // props.getTintControlData(props.guestDetail, (status) => {
      //   if(status){
      //   }
      // })
    })
  }

  function convertTime12to24(time12h) {
    var timeArr = time12h.split(" ");
    var time = timeArr[0];
    var modifier = timeArr[1];
  
    var hourArr = time.split(":");
    var hours = hourArr[0];
    var minutes = hourArr[1];
  
    // var [time, modifier] = time12h.split(" ");
  
    // var [hours, minutes] = time.split(":");
  
    if (hours === "12") {
      hours = "00";
    }
  
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
  
    return `${hours}:${minutes}`;
  }

  const setSchedule = (startTime, endTime) => {
    props.setLoader(true, "Updating Sleep In Schedule...")
    let date = new Date()
    let date2 = new Date(date.getTime() + 86400000);
    let startDate = `${date.getFullYear()}-${getDoubleDigit(date.getMonth()+1)}-${getDoubleDigit(date.getDate())}`
    let endDate = `${date2.getFullYear()}-${getDoubleDigit(date2.getMonth()+1)}-${getDoubleDigit(date2.getDate())}`
    let formatedStartTime = moment(selectedStartHour+":"+selectedStartMinute+" "+selectedStartAMpm,"h:mm A").subtract(utcOffsetMin, "minutes").format("h:mm A");
    let formatedEndTime = moment(selectedEndHour+":"+selectedEndMinute+" "+selectedEndAMpm,"h:mm A").subtract(utcOffsetMin, "minutes").format("h:mm A");

    let schedules = []
    let formatedSchedules = []

    props.tintControlData.zone.forEach((zone, i) => {
      schedules.push({
        "tintCode": zone.tintCode,
        "tintLevel": "4",
        "startDate": `${startDate} ${startTime}`,
        "endDate": `${endDate} ${endTime}`,
      })
      formatedSchedules.push({
        "tintCode": zone.tintCode,
        "tintLevel": "4",
        "tintStartDate": `${startDate}T${formatedStartTime}`,
        "tintEndDate": `${endDate}T${formatedEndTime}`,
      })
    })
    setTimeout(() => {
      props.updateSchedule(props.guestDetail, schedules, (status) => {

        let tintData = {...props.tintControlData}
        let tintSchedule = tintData.schedules

        props.setLoader(false, "")
        if(!status){
          props.closeOrderPopUp(true, "Something went wrong. Please Contact Hotel admin. OR Try again after some time", "",true);
          return
        }
        props.closeOrderPopUp(true, `Sleep-In has been set from ${selectedStartHour+":"+selectedStartMinute+" "+selectedStartAMpm} to ${selectedEndHour+":"+selectedEndMinute+" "+selectedEndAMpm}`, "",false);
        props.setCurrentWindowTintPage("")
        props.setSelectedWindows([])
        props.setSelectedTintLevel(1)

        tintSchedule['sleepIn'] = formatedSchedules
        tintData['schedules'] = tintSchedule

        console.log("tintData", tintData);

        props.seTintControlData(tintData)
        // props.getTintControlData(props.guestDetail, (status) => {
        //   if(status){
        //   }
        // })
      })    
    },50)
  }

  return (
    <div class="main-container">{console.log("props.tintControlData", props.tintControlData)}
      <header class="inner-pages subpages w-footer">
        <a onClick={props.goBack} class="button-back"></a>
        <div class="heading align-center">
          <p class="bold">Sleep-In</p>
        </div>
      </header>

      <div class="widgets currentTint">

      { updateValuesFromTintResponseForSleepResponse(props.tintControlData).bedTime &&
          <div className='widgets'>
          <div class="row">
            <div class="col">
              <p class="heading">Current Tint Duration</p>
            </div>
          </div>

          <div className='row'>
            <div className='col'>
              <div className='timer-container'>

                <div class="timer-details">
                  <div class="timer-name">Bed Time</div>
                  <div className='timer-container2'>
                    <div class="timer-icon sunset">
                      <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.29 50.14"><g id="Layer_1-2"><g><g><path class="cls-sunset" d="M68.5,14.27c1.25,0,2.26-1.01,2.26-2.26V2.26c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26V12.01c0,1.25,1.01,2.26,2.26,2.26Z"></path><path class="cls-sunset" d="M88.41,21.19l5.29-5.29c.88-.88,.88-2.31,0-3.2-.88-.88-2.31-.88-3.2,0l-5.29,5.29c-.88,.88-.88,2.31,0,3.2s2.31,.88,3.2,0Z"></path><path class="cls-sunset" d="M48.6,21.19c.88,.88,2.31,.88,3.2,0,.88-.88,.88-2.31,0-3.2l-5.29-5.29c-.88-.88-2.31-.88-3.2,0-.88,.88-.88,2.31,0,3.2l5.29,5.29Z"></path><path class="cls-sunset" d="M86.49,34.34c-1.88-8.32-9.3-14.54-18.19-14.54s-16.31,6.22-18.19,14.54H30.72v3.91H106.29v-3.91h-19.79Z"></path><rect class="cls-sunset" x="50.31" y="40.28" width="36.38" height="3.91"></rect><rect class="cls-sunset" x="58.46" y="46.23" width="20.07" height="3.91"></rect></g><polygon class="cls-sunset" points="0 25.16 9.65 34.81 9.65 34.82 12.48 37.66 12.49 37.65 12.5 37.66 15.34 34.82 15.33 34.81 24.98 25.16 22.15 22.32 14.5 29.97 14.5 12.48 10.49 12.48 10.49 29.97 2.84 22.32 0 25.16"></polygon></g></g></svg>
                    </div>
                    <div class="timer-text">{updateValuesFromTintResponseForSleepResponse(props.tintControlData).bedTime}</div>
                  </div>
                </div>

                <div class="timer-details">
                  <div class="timer-name">Wake Up</div>
                  <div className='timer-container2'>
                    <div class="timer-icon sunrise">
                      <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.29 50.14"><g id="Layer_1-2"><g><g><path class="cls-sunrise" d="M68.5,14.27c1.25,0,2.26-1.01,2.26-2.26V2.26c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26V12.01c0,1.25,1.01,2.26,2.26,2.26Z"></path><path class="cls-sunrise" d="M88.41,21.19l5.29-5.29c.88-.88,.88-2.31,0-3.2-.88-.88-2.31-.88-3.2,0l-5.29,5.29c-.88,.88-.88,2.31,0,3.2s2.31,.88,3.2,0Z"></path><path class="cls-sunrise" d="M48.6,21.19c.88,.88,2.31,.88,3.2,0,.88-.88,.88-2.31,0-3.2l-5.29-5.29c-.88-.88-2.31-.88-3.2,0-.88,.88-.88,2.31,0,3.2l5.29,5.29Z"></path><path class="cls-sunrise" d="M86.49,34.34c-1.88-8.32-9.3-14.54-18.19-14.54s-16.31,6.22-18.19,14.54H30.72v3.91H106.29v-3.91h-19.79Z"></path><rect class="cls-sunrise" x="50.31" y="40.28" width="36.38" height="3.91"></rect><rect class="cls-sunrise" x="58.46" y="46.23" width="20.07" height="3.91"></rect></g><polygon class="cls-sunrise" points="24.98 24.98 15.33 15.33 15.34 15.32 12.5 12.48 12.49 12.49 12.48 12.48 9.65 15.32 9.65 15.33 0 24.98 2.84 27.82 10.49 20.17 10.49 37.66 14.5 37.66 14.5 20.17 22.15 27.82 24.98 24.98"></polygon></g></g></svg>
                    </div>
                    <div class="timer-text">{updateValuesFromTintResponseForSleepResponse(props.tintControlData).wakeUP}</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      }
      </div>

      <section id="customizeRoom" class="widgets">
        <div class="widgets">
          <div class="row">
            <div class="col">
              <p class="heading">Select Tint Duration</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="tile-rows">
                <div class="timer-container">
                  <div class="timer-details">
                    <div class="timer-name">Bed Time</div>
                    <div class="timer-schedule">
                      <select onChange={(e) => setSelectedStartHour(e.target.value)} value={selectedStartHour}>
                        {["01","02","03","04","05","06","07","08","09","10","11","12"]
                            .map(val => <option key={val} value={val}>{val}</option>)}
                      </select>
                      :
                      <select onChange={(e) => setSelectedStartMinute(e.target.value)} value={selectedStartMinute}>
                        {["00","10","20","30","40","50"].map(val => <option key={val} value={val}>{val}</option>)}
                      </select>
                      <select value={selectedStartAMpm} onChange={e => setSelectedStartAMpm(e.target.value)}>
                        <option value={"AM"}>AM</option>
                        <option value={"PM"}>PM</option>
                      </select>
                    </div>
                  </div>
                  {updateValuesFromTintResponse(props.tintControlData).sunset && <div class="timer-defaults">
                    <div class="timer-icon sunset">
                      <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.29 50.14"><g id="Layer_1-2"><g><g><path class="cls-sunset" d="M68.5,14.27c1.25,0,2.26-1.01,2.26-2.26V2.26c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26V12.01c0,1.25,1.01,2.26,2.26,2.26Z"></path><path class="cls-sunset" d="M88.41,21.19l5.29-5.29c.88-.88,.88-2.31,0-3.2-.88-.88-2.31-.88-3.2,0l-5.29,5.29c-.88,.88-.88,2.31,0,3.2s2.31,.88,3.2,0Z"></path><path class="cls-sunset" d="M48.6,21.19c.88,.88,2.31,.88,3.2,0,.88-.88,.88-2.31,0-3.2l-5.29-5.29c-.88-.88-2.31-.88-3.2,0-.88,.88-.88,2.31,0,3.2l5.29,5.29Z"></path><path class="cls-sunset" d="M86.49,34.34c-1.88-8.32-9.3-14.54-18.19-14.54s-16.31,6.22-18.19,14.54H30.72v3.91H106.29v-3.91h-19.79Z"></path><rect class="cls-sunset" x="50.31" y="40.28" width="36.38" height="3.91"></rect><rect class="cls-sunset" x="58.46" y="46.23" width="20.07" height="3.91"></rect></g><polygon class="cls-sunset" points="0 25.16 9.65 34.81 9.65 34.82 12.48 37.66 12.49 37.65 12.5 37.66 15.34 34.82 15.33 34.81 24.98 25.16 22.15 22.32 14.5 29.97 14.5 12.48 10.49 12.48 10.49 29.97 2.84 22.32 0 25.16"></polygon></g></g></svg>
                    </div>
                    <div class="timer-text">{updateValuesFromTintResponse(props.tintControlData).sunset}</div>
                  </div>}
                </div>
              </div>

              <div class="tile-rows">
                <div class="timer-container">
                  <div class="timer-details">
                    <div class="timer-name">Wake up</div>
                    <div class="timer-schedule">
                      <select onChange={(e) => setSelectedEndHour(e.target.value)} value={selectedEndHour}>
                          {["01","02","03","04","05","06","07","08","09","10","11","12"]
                              .map(val => <option key={val} value={val}>{val}</option>)}
                      </select>
                      :
                      <select onChange={(e) => setSelectedEndMinute(e.target.value)} value={selectedEndMinute}>
                      {["00","10","20","30","40","50"].map(val => <option key={val} value={val}>{val}</option>)}
                      </select>
                      <select value={selectedEndAMpm} onChange={e => setSelectedEndAMpm(e.target.value)}>
                        <option value={"AM"}>AM</option>
                        <option value={"PM"}>PM</option>
                      </select>
                    </div>
                  </div>
                  {updateValuesFromTintResponse(props.tintControlData).sunrise && <div class="timer-defaults">
                    <div class="timer-icon sunrise">
                      <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.29 50.14"><g id="Layer_1-2"><g><g><path class="cls-sunrise" d="M68.5,14.27c1.25,0,2.26-1.01,2.26-2.26V2.26c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26V12.01c0,1.25,1.01,2.26,2.26,2.26Z"></path><path class="cls-sunrise" d="M88.41,21.19l5.29-5.29c.88-.88,.88-2.31,0-3.2-.88-.88-2.31-.88-3.2,0l-5.29,5.29c-.88,.88-.88,2.31,0,3.2s2.31,.88,3.2,0Z"></path><path class="cls-sunrise" d="M48.6,21.19c.88,.88,2.31,.88,3.2,0,.88-.88,.88-2.31,0-3.2l-5.29-5.29c-.88-.88-2.31-.88-3.2,0-.88,.88-.88,2.31,0,3.2l5.29,5.29Z"></path><path class="cls-sunrise" d="M86.49,34.34c-1.88-8.32-9.3-14.54-18.19-14.54s-16.31,6.22-18.19,14.54H30.72v3.91H106.29v-3.91h-19.79Z"></path><rect class="cls-sunrise" x="50.31" y="40.28" width="36.38" height="3.91"></rect><rect class="cls-sunrise" x="58.46" y="46.23" width="20.07" height="3.91"></rect></g><polygon class="cls-sunrise" points="24.98 24.98 15.33 15.33 15.34 15.32 12.5 12.48 12.49 12.49 12.48 12.48 9.65 15.32 9.65 15.33 0 24.98 2.84 27.82 10.49 20.17 10.49 37.66 14.5 37.66 14.5 20.17 22.15 27.82 24.98 24.98"></polygon></g></g></svg>
                    </div>
                    <div class="timer-text">{updateValuesFromTintResponse(props.tintControlData).sunrise}</div>
                  </div>}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
              <div class="col">
                  <p class="desc align-center">Tint transitions are not immediate and can take up to 30 minutes.</p>
                  <img src={view_logo} class="ctl-logo" />
              </div>
          </div>

        </div>
      </section>

      <footer class="button-controls">
        <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
          <button class="primary w-100 all-caps margin-bottom-1" onClick={() => setSchedule(convertTime12to24(selectedStartHour+":"+selectedStartMinute+" "+selectedStartAMpm)+":00", convertTime12to24(selectedEndHour+":"+selectedEndMinute+" "+selectedEndAMpm)+":00")}>Set Sleep-In</button>
          <button class="secondary w-100 all-caps" disabled={props.tintControlData.schedules.sleepIn.length == 0} onClick={deleteSchedule}>Cancel</button>
        </section>
      </footer>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    guestDetail: state.store.home.guestDetails,
    tintControlData: state.store.TintControlData,
  }
}
export default connect(
  mapStateToProps, {
    setLoader,
    updateSchedule,
    setCurrentWindowTintPage,
    setSelectedTintLevel,
    setSelectedWindows,
    setCurrentZoneStep,
    closeOrderPopUp,
    getTintControlData,
    seTintControlData
  }
)(WindowSleepin)